import moment from 'moment';
import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';
import { NegotiationOptionAlternativeType } from '../../../generated/graphql';

const { Refinance, Restructuring, Modification } = NegotiationOptionAlternativeType;

// TODO: monkeypatch o algo que me permita agregar info al space para saber que vino de esta función
export const getSpaceBbva: GetSpaceBase = (group, space, context) => {
  const { negBooleans, outDebt: { extra: outDebtExtra } = {}, alternative } = context;
  const {
    isInstallmentsPlan,
    isConfirmedByUser,
    isRefinance,
    isTotalPayment,
    isPaymentPromise,
    isPunished,
  } = negBooleans!;
  const { disbursementDate, originalTerm } = outDebtExtra || {};
  const { type: alternativeType } = alternative || {};

  switch (group) {
    case 'NEG_OPTION': {
      switch (space) {
        case 'title': {
          if (isRefinance) {
            if (alternativeType === Restructuring) {
              return spaceFactory('NEG_OPTION.title.restructuring').get();
            }
            return spaceFactory('NEG_OPTION.title.refinance').get();
          }
          if (isPaymentPromise) {
            if (isPunished) return spaceFactory('NEG_OPTION.title.paymentPromise.punished').get();
            return spaceFactory('NEG_OPTION.title.paymentPromise').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_CONDITIONS': {
      switch (space) {
        case 'alert': {
          if (isInstallmentsPlan && alternative) {
            //
            const monthsPassed = Math.round(moment().diff(moment(disbursementDate), 'months', true));
            const termsToPay = (originalTerm || 0) - monthsPassed;
            return spaceFactory('NEG_OPTION_CONDITIONS.alert.installmentsPlan').get({ termsToPay });
          }
          break;
        }
        case 'consequences.text': {
          if (isRefinance) {
            switch (alternativeType) {
              case Refinance: {
                if (alternative?.extracupo != null) {
                  return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text.refinance_extracupo').get();
                }
                return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text.refinance').get();
              }
              case Restructuring: {
                if (alternative?.extracupo != null) {
                  return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text.restructuring_extracupo').get();
                }
                return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text.restructuring').get();
              }
              case Modification: {
                return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text.modification').get();
              }
              default: {
                return getUndefinedSpace();
              }
            }
          }
          if (isTotalPayment) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.text.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_CONFIRMATION': {
      switch (space) {
        case 'payment.alert.content': {
          if (isInstallmentsPlan && isConfirmedByUser) return spaceFactory('NEG_CONFIRMATION.payment.alert.content').get();
          break;
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedSpace();
};
